import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { AHText, ListItem } from "arkh";
import React from "react";
import { FormattedMessage } from "react-intl";

export function WorkspaceEmptyListItem(props: {
  type?: "EMPTY_SEARCH" | "EMPTY";
}) {
  const intl_tokens = useIntlTokens();

  return (
    <ListItem isLast border="border-primary">
      <AHText type="subtitle" textAlign="center" color="washedText">
        {props.type === "EMPTY" ? (
          intl_tokens.Empty
        ) : (
          <React.Fragment>
            <FormattedMessage
              defaultMessage="No search results"
              description="WorkspaceEmptyListItem Label"
            />
          </React.Fragment>
        )}
      </AHText>
    </ListItem>
  );
}

export function WorkspaceEmptyFooterItem() {
  return <ListItem isLast border="border-primary" />;
}
